<template>
  <div id="app">
    <div class="part-header">
      <div class="Login">
        <span class="user" v-if="username">
          您好,{{username}}
          <!-- <span @click="handleLogout">【退出】</span> -->
          <br>
          账号积分: {{points}} 分
        </span>
        <div class="btnLogin" v-else>
          <Button
            @click.native="handleChange()"
            bgcolor=" linear-gradient(to right, #d753f0 ,#763ace)"
          >登录</Button>
        </div>
        <Button
          @click.native="handleMyprize"
          bgcolor=" linear-gradient(to right, #d753f0 ,#763ace)"
        >我的奖品</Button>
      </div>
      <div class="inte">
        <ul class="list">
          <li class="listItem" v-for="item in newArr" :key="item.id">
            <img :src="item.imgUrl" alt="签到" class="samllIcon">
            {{item.type}}
          </li>
        </ul>
        <div class="sign">
          <Button
            @click.native="handleSignUp"
            btnsize="1.2rem"
            bgcolor=" linear-gradient(to right, #d753f0 ,#763ace)"
          >{{signin.isSignin==0 ? '签到':'已签到'}}</Button>
          <span>已连续签到 {{signin.days ? signin.days : 0}} 天</span>
        </div>
      </div>
    </div>
    <div class="part-body">
      <div class="tabs">
        <div class="tab" v-for="(item,idx) in tabs" :key="item.tab" @click="changeIdx(idx)">
          <i :class="{icon:true,iconImg:idx===itemIdx}"></i>
          <span :class="{tabFont:true,on:idx===itemIdx}">{{item.tab}}</span>
        </div>
      </div>
      <keep-alive>
        <Draw
          v-if="itemIdx==0"
          :url="urlarg"
          @login="(msg)=>{this.openBingo(msg)}"
          @deduct="handleDeduct"
        />
        <Guess
          v-else-if="itemIdx==1"
          :url="urlarg"
          @login="(msg)=>{this.openBingo(msg)}"
          @deduct="handleDeduct"
        />
        <!-- <Exchange v-else/> -->
      </keep-alive>
      <div class="footer">本活动最终解释权归雷电圈所有</div>
    </div>
    <transition name="fade">
      <Dialog v-if="open.Login" @cancle="handleChange"/>
      <Myprize v-if="open.myprize" @cancle="changeMyprize"/>
      <GetQB
        v-if="open.GetQB"
        :drawId="id"
        @cancle="()=>{this.open.GetQB=!this.open.GetQB;this.open.myprize=true}"
      />
      <GetSw
        v-if="open.GetSw"
        :drawId="id"
        @cancle="()=>{this.open.GetSw=!this.open.GetSw;this.open.myprize=true}"
      />
      <Bingo v-if="open.Bingo" :title="title" @cancle="handleBingo"/>
    </transition>
  </div>
</template>

<script>
import Button from "./common/Button";
import Dialog from "./components/Dialog";
import Myprize from "./components/Myprize";
import Guess from "./components/Guess";
// import Exchange from "./components/Exchange";
import Draw from "./components/Draw";
import GetQB from "./components/GetQB";
import GetSw from "./components/GetSw";
import Bingo from "./common/Bingo";
import qs from "qs";
import ldlogin from "./assets/ldlogin.png";
import unldlogin from "./assets/unldlogin.png";
import login from "./assets/login.png";
import unlogin from "./assets/unlogin.png";
import {Login,signin,is_signin,my_prize,logout} from '../utils/config'

export default {
  name: "app",
  components: {
    Button,
    Dialog,
    Guess,
    // Exchange,
    Draw,
    Myprize,
    Bingo,
    GetQB,
    GetSw
  },
  data: () => ({
    signin: { isSignin: 0 },
    points: 0,
    newArr: [],
    title: "",
    urlarg: {},
    type: "",
    username: "",
    myprize: [],
    open: {
      Login: false,
      myprize: false,
      Bingo: false,
      GetQB: false,
      GetSw: false
    },
    id: 0,
    itemIdx: 0,
    tabs: [{ tab: "每日抽奖" }, { tab: "积分竞猜" }]
  }),
  beforeMount() {
    let obj = {};
    let { search } = window.location;
    if (search) {
      let url = search.slice(1).split("&");
      url.map(item => {
        let str = item.split("=");
        obj[str[0]] = str[1];
      });
      this.urlarg = obj;
    }
    this.$axios({
      withCredentials: true,
      crossDomain: true,
      method: "post",
      transformRequest: [
        function(data) {
          // 对 data 进行任意转换处理
          return qs.stringify(data);
        }
      ],
      url:Login,
      data: {
        uid: obj.uid ? obj.uid : "",
        token: obj.token ? obj.token : ""
      }
    }).then(res => {
      let { data } = res;
      if (data.code == 0) {
        this.username = data.data.username;
        this.points = data.data.points;
      }
      this.handleSignin();
    });
  },
  methods: {
    handleDeduct(msg) {
      let { type, num } = msg;
      if (type == "POINTS") {
        this.points -= 10;
        this.points += num;
      } else if (type == "guess") {
        this.points -= num;
      } else {
        this.points -= 10;
      }
    },
    handleSignUp() {
      if (this.urlarg.from == "ldq") {
        if (this.signin.isSignin == 1) return;
        this.$axios({
          withCredentials: true,
          crossDomain: true,
          method: "get",
          url:signin
        }).then(res => {
          let { data } = res;
          if (data.code == 0) {
            let { data } = res;
            let day = data.data.days;
            let arr = data.data.rewards;
            let newArr = arr.map(item => {
              let obj = {};
              if (item.property2 == "LB") {
                obj.type = item.property3 + "雷币";
                if (day <= 0) {
                  obj.imgUrl = unldlogin;
                } else {
                  obj.imgUrl = ldlogin;
                  day--;
                }
              }
              if (item.property2 == "POINTS") {
                obj.type = item.property3 + "积分";
                if (day <= 0) {
                  obj.imgUrl = unlogin;
                } else {
                  obj.imgUrl = login;
                  day--;
                }
              }
              obj.id = item.id;
              return obj;
            });
            this.signin = data.data;
            this.newArr = newArr;
            this.points = data.data.points;
            this.openBingo("签到成功");
          } else {
            this.openBingo(data.msg);
          }
        });
      } else {
        this.openBingo("请下载安装雷电圈APP");
      }
    },
    handleBingo() {
      let str = this.title;
      if (str.includes("登录")) {
        this.open.Bingo = !this.open.Bingo;
        this.open.Login = true;
      } else {
        this.open.Bingo = !this.open.Bingo;
      }
    },
    openBingo(str) {
      this.title = str;
      this.open.Bingo = true;
    },
    autoFont(item) {
      if (!item) return;
      switch (item.property2) {
        case "LEIB":
          return item.property3 + "雷币";
        case "POINTS":
          return item.property3 + "积分";
        default:
          break;
      }
    },
    handleSignin() {
      this.$axios({
        withCredentials: true,
        crossDomain: true,
        method: "get",
        url:is_signin
      }).then(res => {
        let { data } = res;
        let day = data.data.days;
        let arr = data.data.rewards;
        let newArr = arr.map(item => {
          let obj = {};
          if (item.property2 == "LB") {
            obj.type = item.property3 + "雷币";
            if (day <= 0) {
              obj.imgUrl = unldlogin;
            } else {
              obj.imgUrl = ldlogin;
              day--;
            }
          }
          if (item.property2 == "POINTS") {
            obj.type = item.property3 + "积分";
            if (day <= 0) {
              obj.imgUrl = unlogin;
            } else {
              obj.imgUrl = login;
              day--;
            }
          }
          obj.id = item.id;
          return obj;
        });
        this.signin = data.data;
        this.points = data.data.points;
        this.newArr = newArr;
      });
    },
    handleChange(user) {
      if (this.urlarg.from == "ldq") {
        this.open.Login = !this.open.Login;
        if (user) {
          this.username = user;
          this.handleSignin();
        }
      } else {
        this.openBingo("请下载安装雷电圈APP");
      }
    },
    handleMyprize() {
      if (this.urlarg.from == "ldq") {
        this.$axios({
          method: "get",
          withCredentials: true,
          crossDomain: true,
          url:my_prize
        }).then(res => {
          let { data } = res;
          if (data.code == 0) {
            this.open.myprize = true;
          } else {
            this.openBingo(data.msg);
          }
        });
      } else {
        this.openBingo("请下载安装雷电圈APP");
      }
    },
    handleLogout() {
      this.$axios({
        method: "get",
        withCredentials: true,
        crossDomain: true,
        url:logout
      }).then(res => {
        let { data } = res;
        if (data.code == 0) {
          this.username = "";
          this.handleSignin();
        } else {
          this.openBingo("登出失败");
        }
      });
    },
    changeMyprize(data) {
      if (data) {
        switch (data.type) {
          case "QB":
            this.open.GetQB = true;
            this.id = data.drawId;
            this.open.myprize = !this.open.myprize;
            break;
          case "SW":
            this.open.GetSw = true;
            this.id = data.drawId;
            this.open.myprize = !this.open.myprize;
            break;
          default:
            break;
        }
      } else {
        this.open.myprize = !this.open.myprize;
      }
    },
    changeIdx(idx) {
      this.itemIdx = idx;
    }
  }
};
</script>

<style lang="scss">
@charset "UTF-8";
html,
body,
ul,
li,
ol,
dl,
dd,
dt,
p,
h1,
h2,
h3,
h4,
h5,
h6,
form,
fieldset,
legend,
img,
input {
  margin: 0;
  padding: 0;
}
fieldset,
img,
input,
button {
  border: 0 none;
  padding: 0;
  margin: 0;
  outline-style: none;
} /*去掉input等聚焦时的蓝色边框*/
ul,
li,
ol {
  list-style: none;
}
select,
input {
  vertical-align: middle;
}

/*防止拖动*/
textarea {
  resize: none;
}
img {
  border: 0;
  vertical-align: middle;
}

/* 去掉图片低测默认的3像素空白缝隙，或者用display：block也可以 */
table {
  border-collapse: collapse;
}
a {
  text-decoration: none;
}

* {
  box-sizing: border-box;
}

.clearfix:before,
.clearfix:after {
  content: "";
  display: table;
}
.clearfix:after {
  clear: both;
}
.clearfix {
  *zoom: 1; /*IE/7/6*/
}

/* 设置h标签的大小，设置跟父亲一样大的字体font-size:100%; */
h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: normal;
  font-size: 100%;
}
s,
i,
em {
  font-style: normal;
  text-decoration: none;
}

html,
body {
  font-family: "微软雅黑";
  height: 100%;
}

#app {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  max-width: 1080px;
  margin: 0 auto;
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  .part-header {
    height: 590px;
    background: url("./assets/bg_top_02.jpg") no-repeat 0 0;
    background-size: 100% 101%;
    padding: 368px 46px 0 46px;
    box-sizing: border-box;
    .Login {
      height: 60px;
      display: flex;
      justify-content: space-between;
      .user {
        font-size: 20px;
        color: #fff;
        line-height: 32px;
        text-align: left;
        margin-left: -1vw;
      }
      .btnLogin {
        display: flex;
        margin-left: -1vw;
      }
    }
    .inte {
      flex: 1;
      display: flex;
      justify-content: space-between;
      padding-top: 56px;
      box-sizing: border-box;
      height: 165px;
      .list {
        display: flex;
        margin: 0;
        list-style: none;
        padding: 0;
        margin-left: -4vw;
        .listItem {
          display: flex;
          flex-direction: column;
          align-content: center;
          margin-left: 2.5vw;
          float: left;
          text-align: center;
          height: 80px;
          font-size: 14px;
          color: #cfcfd2;
          img {
            margin-bottom: 14px;
          }
        }
      }
      .sign {
        height: 80px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        color: #ffffff;
        font-size: 14px;
      }
      .samllIcon {
        width: 48px;
        height: 48px;
      }
    }
  }
  .part-body {
    background: url("./assets/bg_btm_02.jpg") no-repeat 0 0;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 60px 0 0 0;
    height: auto;
    position: relative;
    min-height: 60%;
    .tabs {
      display: flex;
      justify-content: space-around;
      padding: 0 84px;
      box-sizing: border-box;
      margin-bottom: 40px;
      .tab {
        // width: 125px;
        height: 45px;
        display: flex;
        .icon {
          width: 18px;
          height: 18px;
          margin: 15px 8px 0 0;
          background: url("./assets/unchecked.png") no-repeat;
          background-size: 100% 100%;
        }
        .iconImg {
          background: url("./assets/checked.png") no-repeat;
          background-size: 100% 100%;
        }
        .tabFont {
          display: block;
          height: 45px;
          font-size: 24px;
          line-height: 45px;
          font-weight: 600;
        }
        .on {
          color: #7624cf;
          border-bottom: 0.03rem solid #7624cf;
        }
      }
    }

    .footer {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
      font-size: 16px;
      height: 35px;
      text-align: center;
    }
  }
}
</style>
